// extracted by mini-css-extract-plugin
export default {"img":"LoginForm_img__DiOjM"};